import { z } from "zod";

const titleField = z
  .string()
  .min(1, "Title is required")
  .max(100, "Title must be at most 100 characters")
  .refine((s) => s.trim().length > 0, "Title is required");

const descriptionField = z
  .string()
  .max(255, "Description must be at most 255 characters");

const accessLevelField = z.enum(["shared", "private"], {
  message: "Select a valid access level",
});

const collaboratorIdsField = z.array(z.string());

// Cover images are uploaded via a separate, project-scoped endpoint
// (PUT /api/projects/{id}/cover) and aren't part of the form payload.
// The create/manage components track the picked File outside of
// react-hook-form and submit it after createProject / alongside save.
export const createProjectFormSchema = z.object({
  title: titleField,
  description: descriptionField,
  accessLevel: accessLevelField,
  collaboratorIds: collaboratorIdsField,
});

export const manageProjectFormSchema = z.object({
  title: titleField,
  description: descriptionField,
  accessLevel: accessLevelField,
  collaboratorIds: collaboratorIdsField,
});

export type CreateProjectFormValues = z.infer<typeof createProjectFormSchema>;
export type ManageProjectFormValues = z.infer<typeof manageProjectFormSchema>;
